export default "__VITE_ASSET__BQGpiSFu__"